<template>
    <div class="w-100">
      <div class="container-box mx-auto">
        <!-- 第一块巨幕 -->
        <div class="w-100 about-warp">
          <!--  巨幕内容 -->
          <div class="about-warp-adv">
            <div class="text-white about-warp-adv-title">About Us</div>
            <div class="text-white about-warp-adv-content w-100">
              <p>
                With the vision swlow, we focus on innovation based on customer needs. We aim to source global electronic compnents and to be your professional components supply chain partner.
              </p>
            </div>
          </div>
        </div>

        <div class="about-whatwedo-box w-100">
          <h3 class="box-title">What We Do</h3>
          <div class="about-whatwedo-box-content d-flex justify-content-around">
            <div class="about-whatwedo-box-content-item" v-for="(item,index) in whatWeDoItems" :key="index">
              <div class="img-wrap d-flex justify-content-center align-items-center">
                <b-img :src="item.img"></b-img>
              </div>
              <p style="text-align: center" class="about-whatwedo-box-content-item-text">{{item.desc}}</p>
            </div>
          </div>
        </div>

        <!-- Company Philosophy  -->
        <div class="w-100 d-flex justify-content-between">
          <div style="width: 721.55px">
              <h3 class="box-title">Company Profile</h3>
              <p>
                Our global purchasing team is experienced at setting up relationships with global suppliers and manufacturers. TZ Electronics is a full-service partner - we have the latest product updates available so our customers can make informed purchasing decisions.
                <br>
                <br>
              We are integrity-based, the pursuit of excellence, our mission is to create value for customers, solve problems for customers, with the greatest efforts to exchange for the trust of every customer. Our goal is to become the world's leading electronic components procurement service agent and distributor. We believe that only better service will become a strong enterprise, we will build a strong and professional one-stop electronic components procurement platform, with high morale to improve our platform, to provide customers with the best quality service.
            </p>
          </div>
          <div style="width: 43%;margin: 14.5px 0 14.5px 50px;">
            <b-img style="width: 100%" src="/imgs/aboutUs/company.png"></b-img>
          </div>
        </div>

        <!-- Quality Assurance  -->
        <div class="w-100 d-flex justify-content-between">
          <div>
            <h3 class="box-title">Quality Assurance</h3>
            <p>
              We have professional QC Team to identify and eliminate defects and errors in products or services before they reach customers. This helps to improve customer satisfaction, reduce costs associated with rework and returns, and increase efficiency and productivity.
            </p>
            <ul class="quality-box">
              <li v-for="imgName in AdvantageItems">
                <b-img :src="`/imgs/manufacturer/${imgName}`"></b-img>
              </li>
            </ul>
          </div>
        </div>

        <!-- Advantage Service -->
        <div class="w-100 d-flex justify-content-between">
          <div>
            <h3 class="box-title">Advantage Service</h3>
            <p>
              Great support from global distributors and OEM excess stock.we offer high quality with competitive price.
            </p>
            <ul class="advantage-box">
              <li>
                <span class="text-active-color advantage-box-title">10,000+</span>
                <p>Daily Order Quantity</p>
              </li>
              <li>
                <span class="text-active-color advantage-box-title">1800+</span>
                <p>Worldwide Manufacturers</p>
              </li>
              <li>
                <span class="text-active-color advantage-box-title">27,000 ㎡</span>
                <p>In-stock Warehouse</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name:"aboutUs",
  data(){
    return {
      whatWeDoItems:[
        {
          img:'/imgs/aboutUs/whatwedo/Integrate.png',
          desc:'Integrated Circuits (ICs)'
        },
        {
          img:'/imgs/aboutUs/whatwedo/Isolators.png',
          desc:'Isolators'
        },
        {
          img:'/imgs/aboutUs/whatwedo/rf.png',
          desc:'RF/IF and RFID'
        },
        {
          img:'/imgs/aboutUs/whatwedo/capa.png',
          desc:'Capacitors'
        },
        {
          img:'/imgs/aboutUs/whatwedo/resistors.png',
          desc:'Resistors'
        }
      ],
      AdvantageItems:[
        "life.png",
        "nxp.png",
        "te.png",
        "microchip.png",
        "fairchild.png",
        "avggo.png",
        "samsung.png",
        "tdk.png",
        "on.png",
        "analog.png",
      ]
    }
  }
}
</script>

<style>
.advantage-box-title{
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}

.advantage-box{
  padding: 0;
  list-style: none;
  margin-top: 20px!important;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px 20px;
}
.quality-box li img{
  width: 100%;
}
.quality-box li{
  border: 1px solid #bec2ca;
  border-radius: 8px;
  padding: 1px;
}
.quality-box{
  padding: 0;
  list-style: none;
  margin-top: 20px!important;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px 20px;
}
.about-whatwedo-box-content-item-text{
  font-weight: bold;
}
.img-wrap img{
  width: 55px;
}
.img-wrap{
  background-color: #f7f5f6;
  width: 100px;
  height: 100px;
  margin: auto;
  border-radius: 20px;
}
.about-whatwedo-box-content-item{
  max-width: 138px;
}
.about-whatwedo-box-content{
  padding: 20px 20px;
}
.about-whatwedo-box{
  padding-top: 20px;
}
.about-warp-adv-content{
  padding-top: 12px;
}
.about-warp-adv-title{
  margin: 0;
  line-height: 60px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  position: relative;
  &::after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 42px;
    height: 3px;
    background: #ff9c00;
  }
}

.about-warp{
  width: 100%;
  height: 0;
  padding-top: 37.74%;
  position: relative;
  background-size: cover;
  background: url("/imgs/aboutUs/bg.jpg") no-repeat center;
}
.about-warp-adv{
  position: absolute;
  top: 219px;
  left: 149px;
  height: 212px;
  width: 724px;
  background: linear-gradient(180deg,rgba(255,255,255,.28) 0,rgba(255,255,255,0) 100%);
  backdrop-filter: blur(34px);
  padding: 20px 20px 30px;
}
</style>
